import * as echarts from 'echarts'
export default {

  /*
  ele               --盛放图表容器
  indicatorNameData --分析项名称
  legendData        --图例，分析指标
  indicatorMaxData  --分析项指标最大值
  areaData1         --分析项第一指标值
  areaData2         --分析项第二指标值
*/
  init (ele, indicatorNameData, legendData,indicatorMaxData, areaData1, areaData2) {
    let radarchart = echarts.init(
      document.getElementById(ele)
    )

    let option = {
      // backgroundColor: '#030d22',
      tooltip: {
        show: true,
        trigger: "item"
      },
      legend: {
        show: true,
        icon: "square",
        left: "30%",
        top: "90%",
        orient: "horizontal",
        textStyle: {
          fontSize: 16,
          color: "#fff"
        },
        data: legendData
      },
      radar: {
        center: ["50%", "48%"],
        radius: "70%",
        startAngle: 90,
        splitNumber: 4,
        shape: "polygon",
        name: {
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: '#0d6dba',
            opacity: 0.1
          }
        },
        axisLabel: {
          show: false,
          fontSize: 14,
          color: "#fff",
          fontWeight: "normal"
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#4f8bbe',
            opacity: 1
          }
        },
        splitLine: {

          lineStyle: {
            color: '#4f8bbe',
            opacity: 0.5
          }
        },
        indicator: [{
          name: indicatorNameData[0],
          max: indicatorMaxData[0],
          axisLabel: {
            show: true
          }
        }, {
          name: indicatorNameData[1],
          max: indicatorMaxData[1]
        }, {
          name: indicatorNameData[2],
          max: indicatorMaxData[2]
        }, {
          name: indicatorNameData[3],
          max: indicatorMaxData[3]
        }, {
          name: indicatorNameData[4],
          max: indicatorMaxData[4]
        }]
      },
      series: [{
        name: legendData[0],
        type: "radar",
        symbol: "circle",
        symbolSize: 10,
        itemStyle: {
          color: 'rgba(245, 166, 35, 1)',
          borderColor: 'rgba(245, 166, 35, 0.3)',
          borderWidth: 10,
        },
        areaStyle: {
          normal: {
            color: "rgba(245, 166, 35, 0.4)"
          }
        },
        lineStyle: {
          normal: {
            type: "dashed",

            color: "rgba(245, 166, 35, 1)",
            width: 2
          }
        },
        data: [
          areaData1
        ]
      }, {
        name: legendData[1],
        type: "radar",
        symbol: "circle",
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: 'rgba(132, 211, 171, 1)',
            borderColor: "rgba(19, 173, 255, 0.3)",
            borderWidth: 10
          }
        },
        areaStyle: {
          normal: {
            color: "rgba(132, 211, 171, 0.4)"
          }
        },
        lineStyle: {
          normal: {
            color: "rgba(132, 211, 171, 1)",
            width: 2,
            type: "dashed"
          }
        },
        data: [
          areaData2
        ]
      }]
    };

    radarchart.setOption(option)
  }
}